import React, {useContext} from 'react';
import {BoShowContext} from "../context/bo-show-context.jsx";
import {FaExternalLinkAlt} from "react-icons/fa";

const BoShowInitialData = () => {
    const {dataFetch, boData, printOptions} = useContext(BoShowContext);

    const initialData = boData?.initialData;
    const boGcm = dataFetch?.bogcm?.bogcm;

    const garrison = () => {
        if (!boData.garrison) return "";

        const garrison = [];
        if (boData.garrison.composition) {
            boData.garrison.composition.forEach((composition, index) => {
                let garrisonContingents = '';
                if(composition.integrants){
                    composition.integrants.forEach(function(integrant) {
                        let contingent = integrant.contingent;
                        if (!contingent) return;

                        if (garrisonContingents === '') {
                            garrisonContingents = contingent.name ? (contingent.name + " (" + contingent.namewar + ")") : contingent.namewar;
                        } else {
                            garrisonContingents += ", " + (contingent.name ? (contingent.name + " (" + contingent.namewar + ")") : contingent.namewar);
                        }
                    });
                }

                garrison.push(
                    <React.Fragment key={"composition-" + index}>
                        <p className={"col-span-2"}>Guarnição: <span className={"info"}>{composition.name ?? ''}</span></p>
                        <p className={"col-span-2"}>Integrantes: <span className={"info"}>{garrisonContingents}</span></p>
                    </React.Fragment>
                )
            })
        }

        if(boData.garrison.animals && boData.garrison.animals.length > 0){

            let garrisonAnimals = '';
            boData.garrison.animals.forEach(function(animal){
                if (garrisonAnimals === '') {
                    garrisonAnimals = animal.name;
                } else {
                    garrisonAnimals += ", " + animal.name;
                }
            });

            garrison.push(
                <p className={"col-span-2"}>Animais: <span className={"info"}>{garrisonAnimals}</span></p>
            )
        }

        return garrison;
    }

    const garrisonSupports = () => {
        const garrisonSupports = [];
        if(boData.garrisonSupport && boData.garrisonSupport.length > 0){

            boData.garrisonSupport.forEach(function(supportsData){

                const garrisonSupportsAnimals = [];
                supportsData.forEach((support, index) => {

                    if(support.name === 'animals'){
                        if(support.integrants !== null){
                            garrisonSupportsAnimals.push(
                                <p key={"animal-support-" + index} className={"col-span-2"}>Animais: <span className={"info"}>{support.integrants}</span></p>
                            )
                        }
                    } else {
                        garrisonSupports.push(
                            <React.Fragment key={"garrison-support-" + index}>
                                <p className={"col-span-2"}>Guarnição: <span className={"info"}>{support.name ?? ''}</span></p>
                                <p className={"col-span-2"}>Integrantes: <span className={"info"}>{support.integrants ?? ""}</span></p>
                            </React.Fragment>
                        )
                    }
                });

                garrisonSupports.push(garrisonSupportsAnimals);
            });
        }

        return garrisonSupports;
    }

    return (
        <article className={"space-y-4"}>
            <h2 className={"resume-title"}>
                DADOS DA EMISSÃO
            </h2>

            <section className={"grid grid-cols-2 gap-2"}>
                <p>Emitido em: <span className={"info"}>{initialData?.creationDate}</span></p>
                <p>Cadastrado por: <span className={"info"}>{boGcm?.userName}</span></p>

                <p className={"flex items-center"}>
                    Local do preenchimento: <span className={"info"}>{boGcm?.data_latitude  ? boGcm.data_latitude + ', ' + boGcm.data_longitude : ''}</span>
                    {
                        boGcm?.data_latitude &&
                        <a className="unprintable cursor-pointer ms-2 !text-[#676a6c]" href={`https://www.google.com/maps/search/?api=1&query=${boGcm.data_latitude}%2C${boGcm.data_longitude}`} target='_blank'>
                            <FaExternalLinkAlt />
                        </a>
                    }
                </p>

                <p className={"hidden" + (printOptions.approvalName ? " print:block" : "")}>
                    Aprovado por: <span className={"info"}>{dataFetch?.bogcm?.lastApprovalUserName}</span>
                </p>
                {garrison()}
                {garrisonSupports()}
            </section>
        </article>
    );
};

export default BoShowInitialData;